import { Link } from "react-router-dom";
import style from "./index.module.css";

const SingleShowroomCard = ({ image, name, location, types, link, notes }: ComponentPropsType) => {
  return (
    <Link to={link} className={style.room}>
      <img src={image} alt="" />
      <div>
        <p>{name}</p>
        {/* {location && <span>{location}</span>} */}
        {types && <span className={style.room_type}>{types}</span>}
        {notes &&
          notes.length > 0 &&
          notes.map((note, index) => (
            <span key={index} className={style.room_note}>
              <b>{note[0]}:</b>
              {note[1]}
            </span>
          ))}
      </div>
    </Link>
  );
};

export default SingleShowroomCard;

type ComponentPropsType = {
  image: string;
  name: string;
  location: string;
  link: string;
  types?: string;
  notes?: string[][];
};
